import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "about" }
const _hoisted_2 = {
  key: 0,
  class: "summary"
}
const _hoisted_3 = { class: "fields" }
const _hoisted_4 = { class: "name" }
const _hoisted_5 = ["href", "onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Ellipsis = _resolveComponent("Ellipsis")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($options.summary)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString($options.summary), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.fields, (field) => {
        return (_openBlock(), _createElementBlock("div", {
          key: field.title,
          class: "field"
        }, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(field.title), 1 /* TEXT */),
          _createVNode(_component_Ellipsis, {
            ref_for: true,
            ref: "ellipsis",
            class: "value ellipsis",
            text: field.value
          }, {
            default: _withCtx(() => [
              (field.value.startsWith('https://'))
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "pointer",
                    href: field.value,
                    onClick: _withModifiers($event => (_ctx.$utils.openLink(field.value)), ["prevent"])
                  }, _toDisplayString(field.value), 9 /* TEXT, PROPS */, _hoisted_5))
                : _createCommentVNode("v-if", true)
            ]),
            _: 2 /* DYNAMIC */
          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["text"])
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}